import { Tag } from "antd";
import { useI18n } from "@/i18n";

export const COURIER_KINDS = ["regular", "instant", "sameday", "cargo"] as const;
export type CourierKind = (typeof COURIER_KINDS)[number];

const COLORS: Partial<Record<string, string>> = { instant: "red", sameday: "orange", cargo: "blue" };

/** Kurir: a tag for a courier that is not a regular one; instant and same day go first. */
export function CourierKindTag({ kind }: { kind?: string }) {
  const { t } = useI18n();
  const color = kind ? COLORS[kind] : undefined;
  if (!color) return null;
  return (
    <Tag color={color} style={{ marginInlineEnd: 0, width: "fit-content" }}>
      {t(`courier.kind.${kind as CourierKind}`)}
    </Tag>
  );
}
